import { CallClientOptions as Options } from "./callClient";

export const CallClientId = "AnywhereRemoteAccess";

export const pointerOptions = {
  innerRadius: 5,
  outerRadius: 20,
  innerColor: "rgba(255,0,0,0.5)",
  outerColor: "rgba(255,0,0,0)",
};

export const CallClientOptions: Options = {
  autoAnswerCall: true,
  userMediaConfig: {
    video: false,
    audio: true,
  },
};

export interface PeerData {
  type: string;
  data: PointerData | string;
}

export interface PointerData {
  x: number;
  y: number;
}

export interface CallRef {
  capture: () => string | undefined;
}

export interface CallProps {
  isCallActive: boolean;
  peerId?: string;
  onEnd: () => void;
  onCaptureScreen: () => void;
}
